import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiClipboardTextOutline } from '@mdi/js';
import { FaCheck } from 'react-icons/fa6';

/**
 * AnnuityProductSection Component
 * Annuity-specific fields for the Product column only
 * (Product Type, Tax Treatment, Carriers)
 */
const AnnuityProductSection = ({ formData, onInputChange, onModalOpen, styles, aaqCriteriaOptions }) => {
  const toggleItem = (arr, item) => (arr.includes(item) ? arr.filter(x => x !== item) : [...arr, item]);

  return (
    <div style={styles.formGrid}>
      {/* Product Type */}
      <div style={styles.formGroup} data-itemid='annuity-product-type-wrapper'>
        <div style={styles.row} data-itemid='annuity-product-type-label-wrapper'>
          <label style={styles.label} data-itemid='annuity-product-type-label'>
            Product Type
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='annuity-product-type-label-required'>
            *
          </label>
        </div>
        <div style={styles.buttonGroup} data-itemid='annuity-product-type-button-group'>
          {aaqCriteriaOptions?.product_types?.map(type => (
            <button
              key={type}
              onClick={() => {
                const current = formData.productTypes || [];
                onInputChange('productTypes', toggleItem(current, type));
              }}
              style={styles.button((formData.productTypes || []).includes(type))}
              type='button'
              data-itemid={`annuity-product-type-button-${type}`}
            >
              {type}
              {(formData.productTypes || []).includes(type) && <FaCheck data-itemid={`annuity-product-type-button-${type}-check`} />}
            </button>
          ))}
        </div>
      </div>

      {/* Tax Treatment */}
      <div style={styles.formGroup} data-itemid='annuity-tax-treatment-wrapper'>
        <label style={styles.label} data-itemid='annuity-tax-treatment-label'>
          Tax Treatment
        </label>
        <div style={styles.buttonGroup} data-itemid='annuity-tax-treatment-button-group'>
          {['Qualified', 'Non-Qualified'].map(treatment => (
            <button
              key={treatment}
              onClick={() => onInputChange('taxTreatment', treatment)}
              style={styles.button(formData.taxTreatment === treatment)}
              type='button'
              data-itemid={`annuity-tax-treatment-button-${treatment}`}
            >
              {treatment}
              {formData.taxTreatment === treatment && <FaCheck data-itemid={`annuity-tax-treatment-button-${treatment}-check`} />}
            </button>
          ))}
        </div>
      </div>

      {/* Carriers */}
      <div style={styles.formGroup} data-itemid='annuity-carriers-wrapper'>
        <div style={styles.row} data-itemid='annuity-carriers-label-wrapper'>
          <label style={styles.label} data-itemid='annuity-carriers-label'>
            Select Carriers
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='annuity-carriers-label-required'>
            *
          </label>
        </div>
        <button
          onClick={() => onModalOpen('carriers')}
          style={{ ...styles.button(false), justifyContent: 'center', display: 'flex', alignItems: 'center', gap: '8px' }}
          type='button'
          data-itemid='annuity-carriers-button'
        >
          <Icon path={mdiClipboardTextOutline} size={0.7} data-itemid='annuity-carriers-button-icon' />
          Select Carriers ({(formData.selectedCarriers || []).length} Selected)
        </button>
      </div>
    </div>
  );
};

AnnuityProductSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onModalOpen: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  aaqCriteriaOptions: PropTypes.object
};

export default AnnuityProductSection;
